/* eslint-disable jsx-a11y/alt-text */
import { Button, Form, Input, message } from 'antd';
import { Formik } from 'formik';
import React, { memo, useCallback, useState } from 'react';
import styled from 'styled-components';
import * as yup from 'yup';
import { AuthApi, UserApi } from '../../apis';
import { useDispatch, useSelector } from 'react-redux';
import { delay } from '../../utils';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import { BlueButtonContainer } from '../../screens/home/home';
import { GeneralState, setForgotPassword } from '../../store/reducer/general';

const validationSchema = yup.object({
  username: yup.string().min(3, 'Хэт богино байна').required('Нэвтэх нэр оруулна уу'),
});

const ForgotForm = memo(() => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const { forgot } = useSelector((state: { general: GeneralState }) => state.general);

  const onSubmit = useCallback(
    async (values: { username?: string }) => {
      setLoading(true);

      try {
        const res = await AuthApi.forgot(values as any);
        console.log('res :', res);
        await delay(1000);
        dispatch(
          setForgotPassword({
            ...forgot,
            username: values?.username,
            otp: res.message,
          })
        );
        setLoading(false);
        navigate(NavigationRoutes.Otp_Screen);
      } catch (error: any) {
        messageApi.open({
          type: 'error',
          content: error?.message,
        });
        setLoading(false);
      }
    },
    [dispatch, forgot, messageApi, navigate]
  );

  return (
    <>
      {contextHolder}
      <Container>
        <Formik
          initialValues={{ username: undefined, password: undefined }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, handleChange, values, errors, touched }) => {
            return (
              <Form layout="vertical">
                <div className="card">
                  <div className="inputContainer">
                    <div className="w-full">
                      <img src={require('../../assets/ochun.png')} className="w-[220px]" />
                    </div>
                    <div className="h100" />

                    <div className="font-bold text-[16px] leading-[130%] tracking-[-0.01em] text-[#05041B] flex flex-1 justify-start w-full">
                      Нууц үг шинэчлэх
                    </div>

                    <div className="h-[12px]" />

                    <div className="font-normal text-[14px] leading-[130%] tracking-[-0.01em] text-[#4B4A49]">
                      Та өөрийн бүртгэлтэй мэйл хаягийг доорх талбарт оруулна уу.Бид таны мэйл хаягт
                      баталгаажуулах код илгээх болно.
                    </div>

                    <div className="h-[24px]" />

                    <Form.Item className="w-[100%]" label="Нэвтрэх нэр">
                      <Input
                        name="username"
                        value={values.username}
                        onChange={handleChange}
                        placeholder="Нэвтрэх нэр оруулна уу"
                        status={touched.username && errors.username ? 'error' : ''}
                      />
                    </Form.Item>

                    <div className="flex w-full">
                      <BlueButtonContainer className="w-full">
                        <Button
                          loading={loading}
                          type="primary"
                          size="large"
                          className="w-full"
                          onClick={() => handleSubmit()}
                        >
                          Код илгээх
                        </Button>
                      </BlueButtonContainer>
                    </div>
                    <div className="h-[20px]" />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Container>
    </>
  );
});

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  border: solid 1px black;
  justify-content: center;

  .title {
    font-weight: 700;
    font-size: 16px;
  }
  .card {
    border: solid 1px #eceaea;
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 18px;
  }
  .inputContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .logo {
    width: 180px;
  }
  .h100 {
    height: 30px;
  }
  .btn {
    width: 100%;
  }
`;

ForgotForm.displayName = 'ForgotForm';

export { ForgotForm };
